<template>
  <span class="txt-analysis-info">
    <font-awesome-icon icon="users" /> {{ value }}
  </span>
</template>

<script type="text/javascript">
export default {
  name: 'VipEnglishName',

  components: {},

  props: {
    // eslint-disable-next-line
    value: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
};
</script>
